"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _GojobLogo = _interopRequireDefault(require("../GojobLogo"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _TouchableOpacity = _interopRequireDefault(require("../TouchableOpacity"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2.default)({
      position: 'absolute',
      top: '50%',
      left: '50%',
      padding: spacing(1, 4),
      textDecoration: 'none',
      transform: "translate(-50%, -50%) translateY(".concat(spacing(-1), ")")
    }, breakpoint.up('lg'), {
      left: 0,
      transform: "translate(0%, -50%) translateY(".concat(spacing(-2), ")")
    }),
    logo: {
      margin: spacing(-1.5, 0)
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, breakpoint }}", function () {
  return [_useTheme2.default];
});

var Logo = function Logo(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_TouchableOpacity.default, (0, _extends2.default)({
    css: classes.root
  }, props), (0, _core.jsx)(_Icon.default, {
    as: _GojobLogo.default,
    css: classes.logo,
    color: "primary",
    size: 10
  }));
};

__signature__(Logo, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Logo;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
  reactHotLoader.register(Logo, "Logo", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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